import { getInitials } from "~/shared/helpers";
import { getAuthorBadgeClass } from "~/shared/lib/author-badge";

/** A person's initials badge, name and role, as the job's author and editor rows show them. */
export const Person = ({
  name,
  role,
  isClient,
  tone,
  spacing = "default",
  testId,
}: {
  name: string;
  role?: string;
  isClient?: boolean;
  /** Badge colours, overriding the staff / client ones. */
  tone?: string;
  /** Badge to name: 6px, or 8px when wide. */
  spacing?: "default" | "wide";
  testId: string;
}) => (
  <>
    {name && (
      <span className={`flex min-w-0 items-center ${spacing === "wide" ? "gap-2" : "gap-1.5"}`}>
        <span
          className={`flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full text-[10px] font-semibold ${tone ?? getAuthorBadgeClass(isClient)}`}
          data-testid={`${testId}-initials`}
        >
          {getInitials(name)}
        </span>
        <span className="truncate font-medium text-text-body" data-testid={`${testId}-name`}>
          {name}
        </span>
      </span>
    )}
    {role && (
      <span className="truncate text-text-subtle" data-testid={`${testId}-role`}>
        {role}
      </span>
    )}
  </>
);
